import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import AgreementView from "../views/AgreementView.vue";
import PrivacyView from "../views/PrivacyView.vue";
import memberUserAgreement from "../views/memberUserAgreement.vue"
import PrivacyPolicy from "../views/PrivacyPolicy.vue";
import UserAgreement from "../views/UserAgreement.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/agreement",
    name: "agreement",
    component: AgreementView,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: PrivacyView,
  },
  {
    path: "/memberUser",
    name: "memberUser",
    component: memberUserAgreement,
  },
  {
      path: "/privacypo",
      name: "privacypo",
      component: PrivacyPolicy
    },
    {
      path: "/useragreement",
      name: "useragreement",
      component: UserAgreement
    },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
